// extracted by mini-css-extract-plugin
export default {"tagContainer":"StageTag_tagContainer__5IpIo","tag":"StageTag_tag__wx1bm","tagText":"StageTag_tagText__bUE+v"};